module.exports = __webpack_public_path__ + "static/media/pdf-layer.6bcf0f41.png";